import CreatableSelect from 'react-select/creatable';
import React, { useState } from 'react';
import { trpc } from '../../api/trpc';
import { useInputState } from '@mantine/hooks';
import useSWR from 'swr';

export const OtcommerceTagsSelector = ({
  onAppend,
}: {
  onAppend: (value: string) => void;
}) => {
  const [isAddingTag, setIsAddingTag] = useState<boolean>(false);
  const [currentInputTag, setCurrentInputTag] = useInputState('');

  const input = { query: currentInputTag, take: 5, skip: 0 };
  const { data: existedTags } = useSWR(
    ['otcRecommendationAdmin.tags', input],
    () => trpc.otcRecommendationAdmin.tags.query(input),
  );
  return (
    <>
      {isAddingTag ? (
        <div>
          <CreatableSelect
            autoFocus
            className={'w-100'}
            options={
              existedTags?.length
                ? existedTags.map((tag) => ({
                    value: tag.name,
                    label: tag.name,
                  }))
                : undefined
            }
            onFocus={() => {
              setCurrentInputTag('');
            }}
            placeholder=""
            formatCreateLabel={(value) => `Добавить "${value}"`}
            onInputChange={(newValue) => {
              setCurrentInputTag(newValue);
            }}
            onChange={(newValue) => {
              setCurrentInputTag('');
              if (newValue) {
                onAppend(newValue.value);
                setIsAddingTag(false);
              }
            }}
            onBlur={() => {
              if (currentInputTag) {
                onAppend(currentInputTag);
                setIsAddingTag(false);
              }
            }}
          />
        </div>
      ) : (
        <div
          className={'btn btn-dashed  align-items-center w-100'}
          onClick={() => {
            setIsAddingTag(true);
          }}
        >
          <i className={'bi bi-plus fs-18 '}></i>Добавить
        </div>
      )}
    </>
  );
};
